import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./AuthContext";
import Layout from "./components/Layout";
import { Spinner } from "./components/ui";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Candidates from "./pages/Candidates";
import RegisterCandidate from "./pages/RegisterCandidate";
import CandidateDetail from "./pages/CandidateDetail";
import CandidateHistory from "./pages/CandidateHistory";
import AdminOrganizations from "./pages/AdminOrganizations";
import AdminOrgDetail from "./pages/AdminOrgDetail";
import AdminSettings from "./pages/AdminSettings";
import Billing from "./pages/Billing";
import PandiDashboard from "./pages/PandiDashboard";

function Protected() {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/candidates" element={<Candidates />} />
            <Route path="/candidates/new" element={<RegisterCandidate />} />
            <Route path="/candidates/:id/edit" element={<RegisterCandidate />} />
            <Route path="/candidates/:id/history" element={<CandidateHistory />} />
            <Route path="/candidates/:id" element={<CandidateDetail />} />
            <Route path="/admin/organizations" element={<AdminOrganizations />} />
            <Route path="/admin/organizations/:id" element={<AdminOrgDetail />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/pandi" element={<PandiDashboard />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
